import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import { ButtonMode, ClosetMode } from '../../config';
import { message } from 'antd';

const Content = observer(() => {
    const { closetManager, drawingManager, viewManager } = useMainContext();

    let drawText =
        viewManager.buttonMode != ButtonMode.Unit ? 'Draw Closet' : 'Draw Unit';

    let deleteText = 'Delete';

    const isDisabled = !viewManager.doUserHasAccess();

    const drawCloset = () => {
        if (isDisabled) return;
        if (closetManager.selectedPageUnit().length < 1) {
            message.error('Please Add a unit first');
            return;
        }
        drawingManager.prepareCanvasForDrawing();
        if (closetManager.getUnitsInSelectedPage() == 0) {
            message.error('Please Add a unit first');
            return;
        }
        if (drawingManager.isDrawingModeOn) {
            drawingManager.setDrawingMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDoorMode(false);
        drawingManager.setRectangleMode(false);
        drawingManager.setDrawingForm(false);
        drawingManager.setUnitMode(false);
        drawingManager.stopDrawing();
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
        drawingManager.setDrawingMode(true);
    };

    const drawRectangleCloset = () => {
        if (isDisabled) return;
        if (drawingManager.isRectangleModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        if (closetManager.selectedPageUnit().length < 1) {
            message.error('Please Add a unit first');
            return;
        }
        drawingManager.prepareCanvasForDrawing();
        if (closetManager.getUnitsInSelectedPage() == 0) {
            message.error('Please Add a unit first');
            return;
        }
        if (drawingManager.isDrawingModeOn && drawingManager.isUnitModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDrawingMode(false);
        drawingManager.setDoorMode(false);
        drawingManager.setDrawingForm(false);
        drawingManager.setUnitMode(false);
        drawingManager.stopDrawing();
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
        drawingManager.setRectangleMode(true);
    };

    const drawRectangleUnit = () => {
        if (isDisabled) return;
        if (drawingManager.isRectangleModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.prepareCanvasForDrawing();
        if (drawingManager.isDrawingModeOn && !drawingManager.isUnitModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDrawingMode(false);
        drawingManager.setDoorMode(false);
        drawingManager.setDrawingForm(false);
        drawingManager.setUnitMode(false);
        drawingManager.stopDrawing();
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
        drawingManager.setRectangleMode(true);
    };

    const drawUnit = () => {
        if (isDisabled) return;
        if (drawingManager.isUnitModeOn) {
            drawingManager.setUnitMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDrawingMode(false);
        drawingManager.setRectangleMode(false);
        drawingManager.stopDrawing();
        drawingManager.setDoorMode(false);
        drawingManager.setUnitMode(true);
        drawingManager.setDrawingForm(false);
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
    };

    return (
        <div className="flex gap-[16px]">
            <button
                disabled={isDisabled}
                onClick={() => {
                    viewManager.buttonMode != ButtonMode.Unit
                        ? drawCloset()
                        : drawUnit();
                }}
                className={`h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                    isDisabled
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                        : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                } ${
                    (drawingManager.isDrawingModeOn &&
                        closetManager.units.length > 0) ||
                    drawingManager.isUnitModeOn
                        ? 'active'
                        : ''
                }
                `}>
                {drawText}
            </button>
            {viewManager.buttonMode !== ButtonMode.Unit && (
                <button
                    disabled={isDisabled}
                    onClick={drawRectangleCloset}
                    className={`h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                        isDisabled
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                            : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                    } ${drawingManager.isRectangleModeOn ? 'active' : ''}`}>
                    Draw Rectangle Closet
                </button>
            )}
            {viewManager.buttonMode === ButtonMode.Unit && (
                <button
                    disabled={isDisabled}
                    onClick={drawRectangleUnit}
                    className={`h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                        isDisabled
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                            : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                    } ${drawingManager.isRectangleModeOn ? 'active' : ''}`}>
                    Draw Rectangle Unit
                </button>
            )}
            <button
                disabled={isDisabled}
                onClick={() => {
                    if (isDisabled) return;
                    drawingManager.setDrawingForm(false);
                    if (
                        closetManager.closetMode === ClosetMode.DELETE &&
                        viewManager.buttonMode != ButtonMode.Door
                    ) {
                        closetManager.setDeleteMode();
                    } else {
                        if (
                            (viewManager.buttonMode == ButtonMode.Closet &&
                                closetManager.selectedPageCloset().length <
                                    1) ||
                            (viewManager.buttonMode == ButtonMode.Unit &&
                                closetManager.selectedPageUnit().length < 1)
                        ) {
                            if (viewManager.buttonMode == ButtonMode.Closet) {
                                message.error('Please Add a closet first');
                            } else {
                                message.error('Please Add a unit first');
                            }
                            return;
                        }
                        drawingManager.setRectangleMode(false);
                        drawingManager.setDrawingMode(false);
                        closetManager.setObstacleForm(false);
                        drawingManager.stopDrawing();
                        closetManager.setDeleteMode();
                    }
                    if (viewManager.buttonMode == ButtonMode.Door) {
                        viewManager.setButtonMode(ButtonMode.Closet);
                        closetManager.setDeleteMode();
                        drawingManager.setDrawingMode(false);
                        closetManager.setObstacleForm(false);
                        drawingManager.stopDrawing();
                        closetManager.setDeleteMode();
                    }
                }}
                className={`h-[32px] w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                    isDisabled
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                        : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                } ${drawingManager.isDeleteMode && viewManager.buttonMode != ButtonMode.Door ? 'active' : ''}`}>
                {deleteText}
            </button>
            {(viewManager.buttonMode == ButtonMode.Closet ||
                viewManager.buttonMode == ButtonMode.Door) && (
                <>
                    <button
                        disabled={isDisabled}
                        onClick={() => {
                            if (isDisabled) return;
                            if (
                                closetManager.closetMode ===
                                    ClosetMode.DELETE &&
                                viewManager.buttonMode == ButtonMode.Door
                            ) {
                                closetManager.setDeleteMode();
                                viewManager.setButtonMode(ButtonMode.Closet);
                            } else {
                                if (
                                    closetManager.selectedPageAttachment()
                                        .length < 1 &&
                                    closetManager.selectedPageObstacle()
                                        .length < 1
                                ) {
                                    message.error(
                                        'Please Add a door/obstacle first',
                                    );
                                    return;
                                }
                                viewManager.setButtonMode(ButtonMode.Door);
                                drawingManager.setDrawingForm(false);
                                closetManager.setDeleteMode();
                                drawingManager.setRectangleMode(false);
                                drawingManager.setDrawingMode(false);
                                closetManager.setObstacleForm(false);
                                drawingManager.stopDrawing();
                                closetManager.setDeleteMode();
                            }
                        }}
                        className={`h-[32px] w-auto border-[1px] border-theme-button-bg p-[5px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                            isDisabled
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                                : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                        } ${drawingManager.isDeleteMode && viewManager.buttonMode == ButtonMode.Door ? 'active' : ''}`}>
                        Delete Door/Window/Obstacle
                    </button>
                    <button
                        disabled={isDisabled}
                        onClick={() => {
                            if (isDisabled) return;
                            drawingManager.setRectangleMode(false);
                            if (closetManager.selectedPageCloset().length < 1) {
                                message.error('Please Add a closet first');
                                return;
                            }
                            if (closetManager.closetMode == ClosetMode.DELETE) {
                                closetManager.setDeleteMode();
                            }
                            viewManager.setButtonMode(ButtonMode.Closet);
                            const setupBool = drawingManager.isDoorModeOn;
                            drawingManager.setDoorMode(
                                !drawingManager.isDoorModeOn,
                            );
                            drawingManager.setDrawingForm(
                                !drawingManager.drawingForm,
                            );
                            drawingManager.stopDrawing();
                            if (setupBool) {
                                closetManager.setDistanceLabel(true);
                                closetManager.drawNewClosets();
                            }
                        }}
                        className={`h-[32px] w-auto border-[1px] border-theme-button-bg p-[5px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                            isDisabled
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                                : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                        } ${drawingManager.isDoorModeOn ? 'active' : ''}`}>
                        Add Door/Window
                    </button>
                    <button
                        disabled={isDisabled}
                        onClick={() => {
                            if (isDisabled) return;
                            if (closetManager.selectedPageCloset().length < 1) {
                                message.error('Please Add a closet first');
                                return;
                            }
                            drawingManager.setDrawingForm(false);
                            drawingManager.stopDrawing();
                            if (closetManager.closetMode == ClosetMode.DELETE) {
                                closetManager.setDeleteMode();
                            }
                            viewManager.setButtonMode(ButtonMode.Closet);
                            if (
                                closetManager.closetMode === ClosetMode.OBSTACLE
                            ) {
                                closetManager.setObstacleMode(false);
                                closetManager.setDistanceLabel(true);
                                closetManager.drawNewClosets();
                                return;
                            } else {
                                drawingManager.setDrawingMode(false);
                                drawingManager.setRectangleMode(false);
                                drawingManager.stopDrawing();
                                closetManager.setObstacleMode(true);
                            }
                        }}
                        className={`h-[32px] w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                            isDisabled
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                                : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                        } ${closetManager.closetMode === ClosetMode.OBSTACLE ? 'active' : ''}`}>
                        Add Obstacle
                    </button>
                </>
            )}
        </div>
    );
});
export default Content;
